exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (orientation:landscape) {\n.am-vue-modal-responsive-screen {\n    top: 0 !important;\n}\n}\n@media screen and (orientation:portrait) {\n.am-vue-modal-responsive-screen {\n    top: 0 !important;\n}\n}\n", ""]);

// exports
